<template lang="pug">
	v-toolbar(
		:class="{fullscreen, divider, 'center': !closable && !fullscreen, closeRight}"
		flat
	).dialogToolbar
		slot(name="append")
			v-btn(v-if="closable" @click="close" :disabled="disabled" small depressed text fab).gray-950--text
				PoIcon(icon="close" size="16")
		v-spacer(v-if="closable && closeRight")
		v-toolbar-title(v-if="hasHeader" :class="{'ml-2 ml-md-3': closable}").font-weight-bold.gray-950--text {{header | capitalize}}
		v-spacer(v-if="closable && !closeRight")
		slot
</template>
<script lang="ts">
	import {Component, Prop, Vue} from "vue-property-decorator"

	@Component({components: {}})
	export default class DialogToolbar extends Vue {
		@Prop({type: Boolean})
		public readonly fullscreen!: boolean
		@Prop({type: Boolean})
		public closable!: boolean
		@Prop({type: Boolean})
		public noDivider!: boolean
		@Prop({type: Boolean})
		public closeRight!: boolean
		@Prop({type: Boolean})
		public disabled!: boolean
		@Prop({default: null})
		public header!: string | null

		private get hasHeader(): boolean {
			return this.header !== null
		}

		private get divider(): boolean {
			return !this.fullscreen && !this.noDivider
		}

		private close(): void {
			this.$emit("close")
		}
	}
</script>
<style lang="sass" scoped>
	.dialogToolbar
		flex: none
		height: 65px !important
		+mq(md)
			height: 78px !important
		&.fullscreen
			padding-top: env(safe-area-inset-top, 0) !important
			height: calc(env(safe-area-inset-top, 0) + 56px) !important
			padding-right: 2px
			box-shadow: $topbar-shadow !important
			z-index: 2
			+mq(md)
				height: calc(env(safe-area-inset-top, 0) + 80px) !important
		&.center
			::v-deep .v-toolbar__content
				justify-content: center
		&.closeRight
			::v-deep .v-toolbar__content
				padding: 0 10px 0 17px
				flex-direction: row-reverse
		&.divider
			border-bottom: 1px solid $gray-200
		::v-deep .v-toolbar__title
			font-size: +rem(22)
			+mq(md)
				font-size: +rem(26)
		::v-deep .v-toolbar__content
			padding: 0 17px 0 7px
			height: 100% !important
			.v-btn
				min-width: 0
</style>
